import React from "react";
import ForgotPasswordModalComponent from "../Login/ForgotPasswordModalComponent";
import {useSelector} from "react-redux";
import {RootState} from "../../Store/Reducers";
import RecoveryPasswordModal from "../Login/RecoveryPasswordModal";
import PickupModalComponent from "../Shared/Modals/CreateShipmentModalComponent";
import ShippingDetailModal from "../Shared/Modals/ShippingDetailModal";
import ConfirmModalComponent from "../Shared/Modals/ConfirmModalComponent/ConfirmModalComponent";
import ContactModalComponent from "../Shared/Contact/ContactModalComponent";
import ContactsListModalComponent from "../Shared/Contact/ContactsListModalComponent";
import AddressListModalComponent from "../Shared/Modals/Address/AddressListModalComponent";
import AddressModalComponent from "../Shared/Modals/Address/AddressModalComponent";
import CancelShipmentModal from "../Shared/Modals/CancelShipmentModal";
import EditPickupModalComponent from "../Shared/Modals/EditPickupModalComponent";
import ShipmentProveModal from "../Shipment/ShipmentProveModal/ShipmentProveModal";

const ModalWrapperComponent = () => {

  const {
    forgotPasswordModal,
    recoverPasswordModal,
    pickupModal,
    shippingDetailModal,
    confirmModal,
    contactModal,
    contactsListModal,
    addressesListModal,
    addressModal,
    cancelShipmentModal,
    editPickupModal,
    shipmentProveModal
  } = useSelector((state: RootState) => state.ModalReducer);

  return (
    <>
      {forgotPasswordModal.open && <ForgotPasswordModalComponent/>}
      {recoverPasswordModal.open && <RecoveryPasswordModal/>}
      {pickupModal.open && <PickupModalComponent/>}
      {shippingDetailModal.open && <ShippingDetailModal/>}
      {confirmModal.open && <ConfirmModalComponent/>}
      {contactModal.open && <ContactModalComponent/>}
      {contactsListModal.open && <ContactsListModalComponent/>}
      {addressesListModal.open && <AddressListModalComponent/>}
      {addressModal.open && <AddressModalComponent/>}
      {cancelShipmentModal.open && <CancelShipmentModal/> }
      {editPickupModal.open && <EditPickupModalComponent/> }
      {shipmentProveModal.open && <ShipmentProveModal/>}
    </>
  );
};

export default ModalWrapperComponent;
